import React from 'react';

import { LockOutlined } from '@ant-design/icons';

import { Permission, enumLabel } from '@enums/permission';
import { NotificationInstance } from 'antd/es/notification/interface';
import SecurityRestrictionControl from '../controls/security-restriction/security-restriction-control';

const duration: number = 10;

export const exception = (api: NotificationInstance, title: string, ex: any, logout: any) => {
    api.error({
        title: title,
        description: ex && ex.userMessage && ex.userMessage.replace(/\r/g, ', '),
        placement: 'bottomRight',
        duration: duration,
    });

    if (ex.statusCode === 401 && logout) logout();
};

export const error = (api: NotificationInstance, title: string, description: string = '') => {
    api.error({
        title: title,
        description: description,
        placement: 'bottomRight',
        duration: duration,
    });
};

export const success = (api: NotificationInstance, title: string, description: string = '') => {
    api.success({
        title: title,
        description: description,
        placement: 'bottomRight',
        duration: duration,
    });
};

export const warning = (api: NotificationInstance, title: string, description: any = undefined) => {
    api.warning({
        title: title,
        description: description,
        placement: 'bottomRight',
        duration: duration,
    });
};

export const info = (api: NotificationInstance, title: string, description: any = undefined) => {
    api.info({
        title: title,
        description: description,
        placement: 'bottomRight',
        duration: duration,
    });
};

export const securityRestriction = (api: NotificationInstance, permissions: Array<Permission> = []) => {
    const permissionLabel = permissions.map((p) => {
        return enumLabel(p);
    });

    api.open({
        title: 'Ограничение безопасности',
        placement: 'bottomRight',
        description: <SecurityRestrictionControl message={'Извините, у вас нет прав доступа'} permissionLabel={permissionLabel} />,
        duration: duration,
        icon: <LockOutlined />,
        style: { width: 600 },
    });
};
